<!--US Page-->
<div class="dtfprograms" *ngIf="!isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


    <!--Banner-->
    <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Programs_top_37Tint_Image_1140x403.jpg);">
      <section class="mbfs-home-hero__header">
       <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'Programs.TruckTitle' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'Programs.TruckHeader' | translate }}
        </p>
      </section>
    </section>
    <div class="container_dashboard" *ngIf="!isCanadaPortal">
      <!--49X-->
      <div class="row">
         <div class="col-sm-6">
            <div class="card1">
              <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/WST_49X-Factor_Program_Image.jpg) no-repeat; background-size: 100% 100%;">
                <h4 class="dtfbrochures__title">{{ 'Programs.ProgramsTitle1' | translate }}</h4>
                  <div class="row">
                     <h4 class="dtfbrochures__header3">{{ 'Programs.ProgramsHeader2' | translate }}</h4>
                  </div>
                  <div>
                    <p class="dtfbrochures__paragraph1">{{ 'Programs.ProgramsCopy2' | translate }}</p>
                  </div>
                  <br><br>
               </div>
            </div>
         </div>
         <!--FLTR-->
         <div class="col-sm-6">
            <div class="card1">
                <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/FLTR_ComingSoon_Program_Image.jpg) no-repeat; background-size: 100% 100%;">
                <h4 class="dtfbrochures__title">{{ 'Programs.ProgramsTitle2' | translate }}</h4>
                  <div class="row">
                     <h4 class="dtfbrochures__header3">{{ 'Programs.ProgramsHeader2' | translate }}</h4>
                  </div>
                  <div>
                    <p class="dtfbrochures__paragraph1">{{ 'Programs.ProgramsCopy2' | translate }}</p>
                  </div>
                  <br><br>
               </div>
            </div>
         </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
           <div class="card1">
            <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/WST_ComingSoon_Program_Image.jpg) no-repeat; background-size: 100% 100%;">
                <h4 class="dtfbrochures__title">{{ 'Programs.ProgramsTitle3' | translate }}</h4>
                 <div class="row">
                    <h4 class="dtfbrochures__header3">{{ 'Programs.ProgramsHeader3' | translate }}</h4>
                  </div>
                 <div>
                  <p class="dtfbrochures__paragraph1">{{ 'Programs.ProgramsCopy3' | translate }}</p>
                 </div>
                 <br><br>
              </div>
           </div>
        </div>
        <!--FLTR2-->
        <div class="col-sm-6">
           <div class="card1">
            <div class="card-body1" style="background: url(/static/assets/img/dtf-assets/images/redesign/FLTR2_ComingSoon_Program_Image.jpg) no-repeat; background-size: 100% 100%;">
              <h4 class="dtfbrochures__title">{{ 'Programs.ProgramsTitle4' | translate }}</h4>
              <div class="row">
                    <h4 class="dtfbrochures__header3">{{ 'Programs.ProgramsHeader3' | translate }}</h4>
                 </div>
                 <div>
                  <p class="dtfbrochures__paragraph1">{{ 'Programs.ProgramsCopy3' | translate }}</p>
                 </div>
                 <br><br>
              </div>
           </div>
        </div>
      </div>
   </div>
 </div>




